// extracted by mini-css-extract-plugin
module.exports = {"hero-infobar-link":"HeroInfoBarLink_hero-infobar-link__z7ZKe"};